import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import { Loading, useData } from "@/ops/ui";

export const qrUrl = (c) => `${window.location.origin}/operasyon/tara?q=${c.id}.${c.qr_key}`;

export default function QrPrint() {
  const { id } = useParams();
  const [p] = useData(`/ops/admin/projects/${id}`);
  const [cps] = useData(`/ops/admin/projects/${id}/checkpoints`);
  const active = useMemo(() => (cps || []).filter((c) => c.active), [cps]);
  if (!p || !cps) return <Loading />;
  return (
    <div className="mx-auto max-w-5xl bg-white p-6">
      <div className="mb-6 flex items-center justify-between print:hidden">
        <h1 className="text-xl font-extrabold">{p.name} – Kontrol Noktası QR Kodları</h1>
        <button onClick={() => window.print()} className="btn-red !py-2" data-testid="qr-print-btn"><Printer className="h-4 w-4" /> Yazdır</button>
      </div>
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-3" data-testid="qr-grid">
        {active.map((c) => (
          <div key={c.id} className="flex break-inside-avoid flex-col items-center rounded-lg border-2 border-zinc-900 p-4 text-center" data-testid={`qr-card-${c.id}`}>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[color:var(--red)]">Rüzgâr Özel Güvenlik</p>
            <QRCodeSVG value={qrUrl(c)} size={170} level="M" className="my-3" />
            <p className="font-extrabold">{c.name}</p>
            <p className="text-xs text-zinc-500">{c.code} · {p.name}</p>
            <p className="mt-1 text-[10px] text-zinc-400">Yalnızca yetkili personel okutabilir</p>
          </div>
        ))}
      </div>
    </div>
  );
}
